export default __webpack_public_path__ + "../staticImages/productBoxWide-bg.jpg";